import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAi = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M12 2L2 7l10 5 10-5-10-5z" }),
		/* @__PURE__ */ _jsx("path", { d: "M2 17l10 5 10-5" }),
		/* @__PURE__ */ _jsx("path", { d: "M2 12l10 5 10-5" })
	]
});
export default SvgAi;
